export const mfaTokensQueryKeys = {
    all: ['mfaTokens'] as const,
    externalConfigs: () => [...mfaTokensQueryKeys.all, 'externalConfigs'] as const
} as const;
